import React from 'react'
import { apartments } from '../../../utils/redux/config/apartments'
import PageLayout from '../../../components/layouts/PageLayout'
import { coordsAB, coordsCD, coordsC, coordsD, coordsE } from '../../../utils/redux/config/apartments'
import InteractiveMap from '../../../components/ImageMapper'
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic'
import { withNamespaces } from 'react-i18next'
import { translate } from '../../../utils/translate'

class View extends React.Component {
	constructor(props){
        super(props)
		this.imageWrapper = React.createRef()
		this.state = {
			interactiveMapWidth: 0
		}
    }

    componentDidMount () {
		this.setState({
			interactiveMapWidth: this.imageWrapper.current.offsetWidth
		})
	}

	onFloorApartmentClick = area => {
		const { history } = this.props
		const { floorNum } = this.props.match.params
		if ( area.type === 'maisonette') {
			const floor = floorNum - 1
			history.push(`/apartments/${area.entrance}/${floor}/${area.number}`)
			return;
		}
		history.push(`/apartments/${area.entrance}/${floorNum}/${area.number}`)
	}

	render () {
		const { entrance, floorNum } = this.props.match.params
		const { t } = this.props
		const translatedApArr = apartments.map( ap => ({
			...ap,
			type: translate(ap.type),
			position: translate(ap.position),
			status: translate(ap.status)
		}))
		let entranceLabel
		let entranceValue = entrance
		let areas
		switch (entrance) {
			case 'ab': {
				entranceLabel = 'A-B'
				areas = coordsAB[floorNum]
				break
			}
      case 'cd': {
        entranceLabel = 'C-D'
        areas = coordsCD[floorNum]
        break
      }
			case 'c':{
				areas = coordsC[floorNum]
				entranceLabel = 'C'
				entranceValue = 'cd'
				break
			}
			case 'd':{
				areas = coordsD[floorNum]
				entranceLabel = 'D'
				entranceValue = 'cd'
				break
			}
			case 'e': {
				areas = coordsE[floorNum]
				entranceLabel = 'E'
				break
			}
			default: {
				entranceLabel = 'A-B'
				areas = coordsAB[floorNum]
			}
		}
		return <PageLayout showBreadcrumbs>
			<BreadcrumbsItem to='/'>{t('general.home')}</BreadcrumbsItem>
			<BreadcrumbsItem to='/apartments'>{t('general.apartment', { count: 2})}</BreadcrumbsItem>
			<BreadcrumbsItem to={`/apartments/${entranceValue}/${floorNum}`}>{`${t('general.entrance')} ${entranceLabel}, ${t('general.floor')} ${floorNum} `}</BreadcrumbsItem>
			<div className='c-content'>
				<div className='o-wrapper u-padding-vertical'>
					<div ref={this.imageWrapper} className='c-interactive-map__holder u-relative'>
						<InteractiveMap
							url={`/img/floorplans/${entranceValue}/${entrance.toUpperCase()}__fl-${floorNum}-color.png`}
							name='floorplan'
							areas={areas}
							width={this.state.interactiveMapWidth}
							imgWidth={2000}
							fillColor='rgba(0,0,0,0.4)'
							mapType='apartment'
							mapArray={translatedApArr}
							onClickHandler={area => this.onFloorApartmentClick(area)}
                            {...this.props}
                        />
					</div>
				</div>
			</div>
		</PageLayout>
	}
}

export default withNamespaces()(View)



// WEBPACK FOOTER //
// ./src/routes/Floor/components/View.js